import {useMutation} from 'react-query';
import {postCreateBrand} from '.';

const usePostCreateBrand = () => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: FormData) => {
      return postCreateBrand(payload);
    },
  });

  return {mutate, isLoading};
};

export default usePostCreateBrand;
